import { WidgetConverter } from './WidgetConverter';
import { ColumnHelper } from '../content/contentBuilder/Column';
export const ColumnsConverter = {
    convertToDomainModel: (columns) => {
        const conversionResults = columns.reduce((acc, column) => {
            const widget = column.widget ? WidgetConverter.convertToDomainModel(column.widget) : undefined;
            const convertedColumn = ColumnHelper.build(column.id, widget ? widget._id : undefined);
            const updatedColumnIds = [...acc.columnIds, convertedColumn._id];
            if (widget) {
                return { columnIds: updatedColumnIds, fragments: [...acc.fragments, convertedColumn, widget] };
            }
            return { columnIds: updatedColumnIds, fragments: [...acc.fragments, convertedColumn] };
        }, { columnIds: [], fragments: [] });
        return { columnIds: conversionResults.columnIds, fragments: conversionResults.fragments };
    },
    convertToServerModel: (column, content) => {
        const widget = !column.value.widget
            ? undefined
            : WidgetConverter.convertServerModel(content.fragmentsById.get(column.value.widget));
        return {
            id: column._id,
            widget,
        };
    },
};
